import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import DragAndDropList from '../../DragAndDropList';
import LayerItem from '../LayerItem';
import { SketchToolContext } from '../context';
import { changeSortOrder } from '../actions';

// Styless
import styles from './LayerMenu.styles';
const useStyles = makeStyles(styles);

const LayerMenu = ({ layers = [], onChangeSortOrder }) => {
  const classes = useStyles();

  const onDragEnd = results => {
    console.log(results);
    if (!results.destination) {
      return;
    }
    const baseLayer = layers.find(layer => layer.layerType === 'baseLayer');
    const result = Array.from(layers.filter(layer => layer.layerType !== 'baseLayer'));
    const [removed] = result.splice(results.source.index, 1);
    result.splice(results.destination.index, 0, removed);
    result.unshift(baseLayer);

    // filter out any undefined layers (in case there is no base layer)
    onChangeSortOrder(result.filter(layer => layer));
  };

  if (!layers || !layers.length) {
    return null;
  }
  // We get the base layer out of the layer list because it is rendered
  // outside the dragable list.
  const baseLayer = layers.find(layer => layer.layerType === 'baseLayer');
  return (
    <div className={classes.layerMenu} key={'layer-menu-container'}>
      <DragAndDropList
        items={layers.filter(layer => layer.layerType !== 'baseLayer')} // Exclude base layer
        idField="id"
        onDragEnd={onDragEnd}
        component={LayerItem}
      />
      {baseLayer && <LayerItem key={`layerItem${baseLayer.id}`} item={baseLayer} />}
    </div>
  );
};

LayerMenu.propTypes = {
  layers: PropTypes.array,
  onChangeSortOrder: PropTypes.func,
};

export { LayerMenu };
export default () => {
  const {
    state: { layers },
    dispatch,
  } = useContext(SketchToolContext);
  return <LayerMenu layers={layers} onChangeSortOrder={results => dispatch(changeSortOrder(results))} />;
};
